<template>
  <vs-popup class="add-new-my-qualification" id="popup" :title="isCreateMode ? 'ADD QUALIFICATION' : 'UPDATE QUALIFICATION'"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-my-qualification-popup" @submit.prevent="handleSubmit(onClickCreateUpdate)" autocomplete="off">

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="qualification_id" name="qualification_id" rules="required" v-slot="{ errors }">
                <small class="label">Qualification</small>
                <v-select :clearable="false" placeholder="" v-model="form.qualification_id"
                  :options="qualification_list" :dir="$vs.rtl ? 'rtl' : 'ltr'" label="name"
                  :reduce="option => option.id">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="certification_number" name="certification_number" rules=""
                v-slot="{ errors }">
                <small class="label">Certification Number</small>
                <vs-input v-model="form.certification_number" name="certification_number" class="w-full" label=""
                  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="status" name="status" rules="required" v-slot="{ errors }">
                <small class="label">Status</small>
                <v-select :clearable="false" placeholder="" v-model="form.status"
                  :options="['Active', 'Expired', 'Pending Renewal']" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="date_obtained" name="date_obtained" rules="required" v-slot="{ errors }">
                <small class="label">Date Obtained</small>
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" v-model="form.date_obtained" placeholder="Choose Date"
                  class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-full md:mb-0">
              <ValidationProvider vid="expiry_date" name="expiry_date" rules="" v-slot="{ errors }">
                <small class="label">Expiry Date</small>
                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full" v-model="form.expiry_date"
                  placeholder="Choose Date" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="mb-3 vx-row">
            <div class="w-full vx-col">
              <ValidationProvider vid="notes" name="notes" rules="" v-slot="{ errors }">
                <small class="label">Notes</small>
                <vs-textarea class="mb-0" v-model="form.notes" height="150px" />
                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <vx-card carBorder noShadow title="Upload Cerificates">
            <FilePreviewGallery :removable="true" :files="form.uploaded_certificate_path" @remove="removeFile" />

            <br>

            <multi-file-uploader v-on:onSetFileName="onSetFiles($event)" :file="''" file_path="staff-qualifications/cetificates"
              :condition="true" />
          </vx-card>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-ccp-items-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const SkillQualificationRepository = RepositoryFactory.get('skills');
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import FilePreviewGallery from "@/components/shared/FilePreviewGallery.vue"

function initialState() {
  return {
    open: false,
    id: '',
    form: {
      qualification_id: '',
      certification_number: '',
      status: 'Active',
      date_obtained: '',
      expiry_date: '',
      uploaded_certificate_path: [],
      notes: ''
    },
    isCreateMode: true,
    qualification_list: [],
  }
}

export default {
  name: 'AddNewMyQulificationPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(id) {
      try {
        await Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        await this.fetchQualificationList()
        if (!!id) {
          this.id = id
          this.isCreateMode = false
          await this.fetchMyQualificationDetails()
        } else {
          this.isCreateMode = true
        }
      } catch (error) {

      }
    },
    async fetchMyQualificationDetails() {
      await this.$vs.loading({
        container: '#create-my-qualification-popup',
        scale: 0.45
      })
      try {
        const { data } = (await SkillQualificationRepository.getMyQualification(this.id)).data
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-my-qualification-popup > .con-vs-loading')
    },
    async fetchQualificationList() {
      await this.$vs.loading({
        container: '#create-my-qualification-popup',
        scale: 0.45
      })
      try {
        const { data } = (await SkillQualificationRepository.getListOfSkillQualificationsDropdown()).data
        this.qualification_list = data.filter(x => !!x.is_active)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-my-qualification-popup > .con-vs-loading')
    },
    async onClickCreateUpdate() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-my-qualification-popup',
        scale: 0.45
      })
      try {
        if (this.isCreateMode) {
          await SkillQualificationRepository.createMyQualifications(this.$store.getters.currentUserId, this.form);
          this.showSuccessMessage('Qualification added!');
        } else {
          await SkillQualificationRepository.updateMyQualifications(this.id, this.form);
          this.showSuccessMessage('Qualification updated!');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#create-my-qualification-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-my-qualification-popup > .con-vs-loading')
    },
    onSetFiles(file_path) {
      this.form.uploaded_certificate_path.push(file_path)
    },
    removeFile(index) {
      this.form.uploaded_certificate_path.splice(index, 1);
    },
  },
  components: {
    'v-select': vSelect,
    flatPickr,
    FilePreviewGallery
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-new-my-qualification>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 30% !important;
}
</style>
